/**
 * Slim "breaking news" ticker shown above the hero on GamesHome.
 * Reuses whatever articles the page already fetched — no extra API call.
 */
import Link from '@/lib/siteLink';
import { stripTags, formatRelativeTime } from '../utils/gamesFormat';
import { useGamesLanguage } from '../useGamesLanguage';
import { t } from '../i18n';

export default function LiveTicker({ articles = [] }) {
  const { lang } = useGamesLanguage();
  const items = (articles || []).filter((a) => a.title).slice(0, 8);
  if (items.length === 0) return null;

  return (
    <div className="border-b border-slate-200 dark:border-white/5 bg-white/70 dark:bg-black/20" data-testid="games-live-ticker">
      <div className="max-w-6xl mx-auto px-6 py-2.5 flex items-center gap-4">
        <span className="flex items-center gap-1.5 shrink-0 text-[10px] font-black text-red-500 uppercase tracking-widest">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" />
          </span>
          {t('justIn', lang)}
        </span>
        <div className="flex gap-6 scroll-strip">
          {items.map((a) => (
            <Link
              key={a.id}
              to={`/games/blog/${a.slug || a.id}`}
              className="shrink-0 text-xs font-medium text-slate-600 dark:text-gray-300 hover:text-amber-600 dark:hover:text-yellow-400 whitespace-nowrap transition-colors"
              data-testid={`ticker-item-${a.id}`}
            >
              {stripTags(a.title)}
              <span className="text-slate-400 dark:text-gray-500"> · {formatRelativeTime(a.updated_at || a.published_at || a.created_at)}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
